import { render, staticRenderFns } from "./TarifaListagem.vue?vue&type=template&id=7346d6b7&scoped=true&"
import script from "./TarifaListagem.vue?vue&type=script&lang=js&"
export * from "./TarifaListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7346d6b7",
  null
  
)

export default component.exports